<template>
    <div class="index">
        <Head />
        <router-view></router-view>
        <Foot />
    </div>
</template>
<script>
import Head from "../components/header";
import Foot from '../components/footer'
export default {
    data() {
        return {};
    },
    components: { Head ,Foot},
    computed: {},
    methods: {},
};
</script>
<style lang="less" >
    .content{
        padding: 67px 200px 124px;
        .head{
            font-size: 36px;
            margin-top: 8px;
            margin-bottom: 50px;
        } 
    }
    .banner{
        height: 945px;
        img{
            width: 100%;
        }
    }
</style>
